import {
  RECOMPRA_PAQUETE_HAS_ERRORED,
  SET_DATA_RECOMPRA_PAQUETE,
  SET_DATA_RECOMPRA_PAQUETE_ERROR,
  RECOMPRA_PAQUETE_IS_LOADING,
  LIMPIAR_RECOMPRA,
  VALIDAR_PLACAS_POLIZA,
  MSG_VALIDAR_PLACAS_POLIZA,
  LIMPIAR_DATOS_VALIDACIONES_PLACA,
  setCarritoHogar,
  carritoHogarError,
  carritoHogarloading,
  planesHogarAdvanceError,
  planesHogarAdvanceLoading,
  setPlanesHogarAdvance,
  limpiarCarritoHogar,
  setSeccionesCoberturasHogar,
  seccionesCoberturasHogarloading,
  seccionesCoberturasHogarError,
  limpiarSeccionesCoberturasHogar,
  setCalculoPrimaHogar,
  calculoPrimaHogarloading,
  calculoPrimaHogarError,
  limpiarCalculoPrimaHogar,
  setCalculoPrimaHogarErrores,
  limpiarErroresCalculoPrimaHogar,
  setProductoActualHogar,
  limpiarProductoActualHogar,
  generarPdfCotizacionHogarloading,
  generarPdfCotizacionHogarError,
  setGenerarPdfCotizacionHogar,
  limpiarTotalesCabeceraCotizadores,
  setTotalesCabeceraCotizadores,
  // manejo de duplicidades hogar
  setIsDuplicatePoliza,
  setDuplicidadPolizaLoading,
  setDuplicidadPolizaError,
  BANCOS_CUOTAS_IS_LOADING,
  SET_DATA_BANCOS_CUOTAS,
  BANCOS_CUOTAS_HAS_ERRORED,
} from "../actions/APolizas";
import { handleActions } from 'redux-actions'

const initialState = {
  isLoading: false,
  hasErrored: false,
  productosCarrito: {},
  SetValidarPlacasPoliza: true,
  msgValidarPlacas: undefined,
  recompraPaqueteError: 'HOLA'
};
export default function dataRecompraPaquete(state = initialState, action) {
  switch (action.type) {
    case RECOMPRA_PAQUETE_IS_LOADING:
      return {
        ...state,
        isLoading: action.isLoading,
        hasErrored: false
      };
    case BANCOS_CUOTAS_IS_LOADING:
      return {
        ...state,
        isLoading: action.isLoading,
        hasErrored: false
      };
    case SET_DATA_RECOMPRA_PAQUETE:
      return {
        ...state,
        isLoading: false,
        recompraPaquete: action.recompraPaquete,
      };
    case SET_DATA_RECOMPRA_PAQUETE_ERROR:
      return {
        ...state,
        isLoading: false,
        recompraPaqueteError: action.recompraPaqueteError,
      };
    case SET_DATA_BANCOS_CUOTAS:
      return {
        ...state,
        isLoading: false,
        bancosCuotas: action.bancosCuotas,

      };
    case RECOMPRA_PAQUETE_HAS_ERRORED:
      return {
        ...state,
        isLoading: false,
        hasErrored: true
      };
    case BANCOS_CUOTAS_HAS_ERRORED:
      return {
        ...state,
        isLoading: false,
        hasErrored: true
      };
    case LIMPIAR_RECOMPRA:
      return {
        ...state,
        isLoading: false,
        hasErrored: false,
        productosCarrito: null,
        recompraPaquete: null,
        SetValidarPlacasPoliza: true,
        msgValidarPlacas: undefined
      };
    case VALIDAR_PLACAS_POLIZA:
      return {
        ...state,
        isLoading: false,
        hasErrored: false,
        SetValidarPlacasPoliza: false
      };
    case MSG_VALIDAR_PLACAS_POLIZA:
      return {
        ...state,
        isLoading: false,
        hasErrored: false,
        msgValidarPlacas: action.payload
      };
    case LIMPIAR_DATOS_VALIDACIONES_PLACA:
      return {
        ...state,
        isLoading: false,
        hasErrored: false,
        SetValidarPlacasPoliza: true,
        msgValidarPlacas: ""
      };
    default:
      return state;
  }
}


/**
 * 
 * @param {*} state Estado actual del objeto
 * @param {*} action acciones
 * @returns 
 */
export function dataBancosCuotas(state = initialState, action) {
  switch (action.type) {

    case BANCOS_CUOTAS_IS_LOADING:
      return {
        ...state,
        isLoading: action.isLoading,
        hasErrored: false
      };

    case SET_DATA_BANCOS_CUOTAS:
      return {
        ...state,
        isLoading: false,
        bancosCuotas: action.bancosCuotas,
      };

    case BANCOS_CUOTAS_HAS_ERRORED:
      return {
        ...state,
        isLoading: false,
        hasErrored: true
      };

    case VALIDAR_PLACAS_POLIZA:
      return {
        ...state,
        isLoading: false,
        hasErrored: false,
        SetValidarPlacasPoliza: false
      };


    default:
      return state;
  }
}

//COTIZACION HOGAR ----------------------------------------
export const datosDuplicidadPolizas = handleActions(
  {
    // Manejar las duplicidades en hogar
    [setIsDuplicatePoliza]: (state, action) => ({ ...state, isDuplicatePoliza: action.payload }),
    [setDuplicidadPolizaLoading]: (state, action) => ({ ...state, duplicidadPolizaLoading: action.payload }),
    [setDuplicidadPolizaError]: (state, action) => ({ ...state, duplicidadPolizaError: action.payload }),
  },
  // initial state
  {
    isDuplicatePoliza: false,
    duplicidadPolizaLoading: false,
    duplicidadPolizaError: false,
  }
)




export const datosCarritoHogar = handleActions(
  {
    //Guardar informacion en el carrito
    [carritoHogarloading]: (state) => ({ ...state, carritoHogarloading: true, carritoHogarError: false, }),
    [carritoHogarError]: (state) => ({ ...state, carritoHogarError: true, carritoHogarloading: false }),
    [setCarritoHogar]: (state, action) => ({ ...state, setCarritoHogar: action.payload, carritoHogarError: false, carritoHogarloading: false }),

    [planesHogarAdvanceLoading]: (state) => ({ ...state, planesHogarAdvanceLoading: true, planesHogarAdvanceError: false, }),
    [planesHogarAdvanceError]: (state) => ({ ...state, planesHogarAdvanceError: true, planesHogarAdvanceLoading: false }),
    [setPlanesHogarAdvance]: (state, action) => ({ ...state, setPlanesHogarAdvance: action.payload, planesHogarAdvanceError: false, planesHogarAdvanceLoading: false }),

    [limpiarCarritoHogar]: (state) => ({ ...state, setCarritoHogar: {}, carritoHogarError: false, carritoHogarloading: false }),
    //Listar secciones y coberturas
    [seccionesCoberturasHogarloading]: (state) => ({ ...state, seccionesCoberturasHogarloading: true, seccionesCoberturasHogarError: false, }),
    [seccionesCoberturasHogarError]: (state) => ({ ...state, seccionesCoberturasHogarError: true, seccionesCoberturasHogarloading: false }),
    [setSeccionesCoberturasHogar]: (state, action) => ({ ...state, setSeccionesCoberturasHogar: action.payload, seccionesCoberturasHogarError: false, seccionesCoberturasHogarloading: false }),
    [limpiarSeccionesCoberturasHogar]: (state) => ({ ...state, setSeccionesCoberturasHogar: {}, seccionesCoberturasHogarError: false, seccionesCoberturasHogarloading: false }),
    //Calcular la prima 
    [calculoPrimaHogarloading]: (state) => ({ ...state, calculoPrimaHogarloading: true, calculoPrimaHogarError: false, }),
    [calculoPrimaHogarError]: (state) => ({ ...state, calculoPrimaHogarError: true, calculoPrimaHogarloading: false }),
    [setCalculoPrimaHogar]: (state, action) => ({ ...state, setCalculoPrimaHogar: action.payload, calculoPrimaHogarError: false, calculoPrimaHogarloading: false }),
    [limpiarCalculoPrimaHogar]: (state) => ({ ...state, setCalculoPrimaHogar: {}, calculoPrimaHogarError: false, calculoPrimaHogarloading: false }),

    [setCalculoPrimaHogarErrores]: (state, action) => ({ ...state, setCalculoPrimaHogarErrores: action.payload }),
    [limpiarErroresCalculoPrimaHogar]: (state, action) => ({ ...state, setCalculoPrimaHogarErrores: {} }),
    //Establecer producto actual hogar
    [setProductoActualHogar]: (state, action) => ({ ...state, setProductoActualHogar: action.payload }),
    [limpiarProductoActualHogar]: (state, action) => ({ ...state, limpiarProductoActualHogar: {} }),
    //Generar o enviar pdf cotizacion hogar
    [generarPdfCotizacionHogarloading]: (state) => ({ ...state, generarPdfCotizacionHogarloading: true, generarPdfCotizacionHogarError: false }),
    [generarPdfCotizacionHogarError]: (state) => ({ ...state, generarPdfCotizacionHogarError: true, generarPdfCotizacionHogarloading: false }),
    [setGenerarPdfCotizacionHogar]: (state, action) => ({ ...state, setGenerarPdfCotizacionHogar: action.payload, generarPdfCotizacionHogarError: false, generarPdfCotizacionHogarloading: false }),
  },
  {
    // manejo del carrito
    carritoHogarloading: false,
    carritoHogarError: false,
    setCarritoHogar: {},

    setSeccionesCoberturasHogar: {},
    seccionesCoberturasHogarloading: false,
    seccionesCoberturasHogarError: false,

    setCalculoPrimaHogar: {},
    calculoPrimaHogarloading: false,
    calculoPrimaHogarError: false,

    setCalculoPrimaHogarErrores: {},

    setProductoActualHogar: {},

    planesHogarAdvanceLoading: false,
    planesHogarAdvanceError: false,
    setPlanesHogarAdvance:
    {
      planContenidos:
        [
          {
            id: 0,
            titulo: 'PLAN 1',
            incendioAliadas: '10.000,00',
            robo: '4.000,00',
            danosEquipoElectrico: '1.000,00',
            accidentesPersonales: '5.000,00',
            servicioReparacionElectrodomesticos: '250,00',
            llavesProgidas: '300,00',
            billeteraProtegida: '300,00',
            firmaConImpuestos: '115,06'
          },
          {
            id: 1,
            titulo: 'PLAN 2',
            incendioAliadas: '20.000,00',
            robo: '8.000,00',
            danosEquipoElectrico: '2.000,00',
            accidentesPersonales: '10.000,00',
            servicioReparacionElectrodomesticos: '500,00',
            llavesProgidas: '600,00',
            billeteraProtegida: '600,00',
            firmaConImpuestos: '215,06'
          }
        ],
      planEstructura:
        [
          {
            id: 0,
            titulo: 'PLAN A',
            incendioAliadas: '10.000,00',
            remocionEscombros: '4.000,00',
            honorariosArquitecto: '4.000,00',
            roturaVidrios: '1.600,00',
            extintores: '300,00',
            perdidaArrendamiento: '4.000,00',
            responsabilidadCivil: '3.000,00',
            firmaConImpuestos: '189,89'
          },
          {
            id: 1,
            titulo: 'PLAN B',
            incendioAliadas: '20.000,00',
            remocionEscombros: '8.000,00',
            honorariosArquitecto: '4.000,00',
            roturaVidrios: '2.600,00',
            extintores: '600,00',
            perdidaArrendamiento: '8.000,00',
            responsabilidadCivil: '6.000,00',
            firmaConImpuestos: '289,89'
          }

        ]
    },

    setSeccionesCoberturasHogar: {},
    seccionesCoberturasHogarloading: false,
    seccionesCoberturasHogarError: false,

    setCalculoPrimaHogar: {},
    calculoPrimaHogarloading: false,
    calculoPrimaHogarError: false,

    setCalculoPrimaHogarErrores: {},

    setProductoActualHogar: {},

    setGenerarPdfCotizacionHogar: {},
    generarPdfCotizacionHogarloading: false,
    generarPdfCotizacionHogarError: false,
  }
);


//FIN COTIZACION HOGAR ----------------------------------------
export const datosTotalesCabeceraCotizadores = handleActions(
  {
    //Establecer totales cabecera Cotizadores
    [setTotalesCabeceraCotizadores]: (state, action) => ({ ...state, setTotalesCabeceraCotizadores: action.payload }),
    [limpiarTotalesCabeceraCotizadores]: (state, action) => ({ ...state, setTotalesCabeceraCotizadores: { pathIcono: "", totalItems: "0", totalPrima: "0.00", ramoCotizador: "" } }),
  },
  {
    setTotalesCabeceraCotizadores: { pathIcono: "", totalItems: "0", totalPrima: "0.00", ramoCotizador: "" },
  }
);

//TOTALES CABECERA COTIZADORES ----------------------------------------